import { Link } from 'react-router-dom';
import { siteInfo } from '@/mocks/home';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden" aria-label="首屏焦点区">
      <img
        src="https://readdy.ai/api/search-image?query=Dark%20moody%20urban%20cityscape%20at%20night%20with%20neon%20lights%20reflecting%20on%20wet%20streets%2C%20cinematic%20atmosphere%2C%20dramatic%20lighting%2C%20deep%20shadows%2C%20mysterious%20vibe%2C%20grainy%20film%20texture%2C%20desaturated%20colors%20with%20subtle%20warm%20highlights%2C%20editorial%20photography%20style%2C%20dark%20alleyway%20aesthetic&width=1800&height=1200&seq=hero-bg-2026&orientation=landscape"
        alt="黑料吃瓜爆料中心 - 每日爆料不打烊"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/60"></div>

      <div className="relative z-10 w-full h-full flex flex-col justify-center px-4 md:px-12 lg:px-20">
        <div className="max-w-3xl">
          <span className="inline-block px-4 py-1.5 rounded-full border border-background-50/40 text-background-50 text-xs md:text-sm font-medium mb-6">
            🔥 实时更新 · 24H不打烊
          </span>

          <h1 className="font-heading text-3xl md:text-5xl lg:text-7xl font-bold text-background-50 leading-tight mb-4">
            每日大赛
            <br />
            正能量不打烊
          </h1>

          <p className="text-background-50/70 text-sm md:text-lg leading-relaxed mb-8 max-w-xl">
            {siteInfo.description}
          </p>

          <div className="flex flex-col sm:flex-row gap-3">
            <Link
              to="/category/daily-contest"
              className="whitespace-nowrap inline-flex items-center justify-center gap-2 px-8 py-3 rounded-full bg-primary-500 text-background-50 font-semibold text-sm md:text-base hover:bg-primary-600 transition-colors cursor-pointer"
            >
              立即吃瓜
              <i className="ri-arrow-right-line"></i>
            </Link>
            <Link
              to="/category/shichui-baoguang"
              className="whitespace-nowrap inline-flex items-center justify-center gap-2 px-8 py-3 rounded-full border border-background-50/40 text-background-50 font-medium text-sm md:text-base hover:bg-background-50/10 transition-colors cursor-pointer"
            >
              实锤曝光
              <i className="ri-search-eye-line"></i>
            </Link>
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10 hidden md:block">
        <div className="flex items-center gap-8 text-background-50/50 text-xs">
          <span className="flex items-center gap-1.5">
            <span className="w-1.5 h-1.5 rounded-full bg-accent-500"></span>
            实时更新中
          </span>
          <span className="flex items-center gap-1.5">
            <span className="w-1.5 h-1.5 rounded-full bg-primary-400"></span>
            今日已更新 127 条
          </span>
          <span className="flex items-center gap-1.5">
            <span className="w-1.5 h-1.5 rounded-full bg-accent-400"></span>
            在线吃瓜 38.6万人
          </span>
        </div>
      </div>
    </section>
  );
}